import { Component } from '@verndale/core';
import { open, close } from '../helpers';
import { customEvents } from '../helpers/constants';

class Module extends Component {
  setupDefaults() {
    this.id = this.el.dataset.id;

    this.dom = {
      toggle: this.el.querySelector('.alert-banner__toggle'),
      close: this.el.querySelector('.alert-banner__close'),
      content: this.el.querySelector('.alert-banner__content')
    };

    this.shouldDisplayAlert();
  }

  shouldDisplayAlert() {
    this.alerts = localStorage.getItem('aspen_alerts');

    if (this.alerts) {
      this.alerts = JSON.parse(this.alerts);

      if (this.alerts.includes(this.id)) {
        return this.el.remove();
      }
    } else {
      this.alerts = [];
    }

    open({
      element: this.el,
      onComplete: () => {
        (this.el.style.height = 'auto');
        this.updateLeftBorder();
      }
    });
  }

  addListeners() {
    this.dom.toggle?.addEventListener('click', this.handleCollapse.bind(this));
    this.dom.close?.addEventListener('click', this.handleClose.bind(this));
  }

  updateLeftBorder() {
    const resizeEvent = new CustomEvent(customEvents.leftBorderResizeTrigger);
    window.dispatchEvent(resizeEvent);
  }

  handleCollapse() {
    const expanded = this.dom.toggle.getAttribute('aria-expanded') === 'true';
    this.updateLeftBorder();
    if (expanded) {
      this.dom.toggle.setAttribute('aria-expanded', false);
      close({
        element: this.dom.content
      });
    } else {
      this.dom.toggle.setAttribute('aria-expanded', true);
      open({
        element: this.dom.content
      });
    }
  }

  handleClose() {
    this.updateLeftBorder();
    this.alerts.push(this.id);

    close({
      element: this.el,
      onComplete: () => {
        localStorage.setItem('aspen_alerts', JSON.stringify(this.alerts));
        this.el.remove();
      }
    });
  }
}

export default Module;
